import Api from '@/api/Api';
import mixins from 'vuex-store/mixins';

const api = new Api({ name: 'MS_CATALOG_API_URL' });

const state = () => ({
  popular: [],
});

const getters = {
  hasPopular: ({ popular }) => Object.keys(popular).length > 0,

  getPopularById: (state, getters) => (id) =>
    getters.hasPopular ? state.popular.find(({ my_soco_sql_id }) => my_soco_sql_id == id) : false,

  getPopularTitle: (state, getters) =>
    getters.hasPopular
      ? {
          ...Object.fromEntries(state.popular.map(({ name }, index) => [index, name])),
        }
      : {},
};

const actions = {
  getCategories: (context, payload) =>
    api
      .getData({
        endpoint: '/categories',
        params: payload,
      })
      .then(({ data: { data } }) => data),
};

const mutations = {
  ...mixins.mutations,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
